import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.add-users-to-labels', {
        url: '/copy',
        params: {users: [],labels:[]},
        views: {
            '@company': 'companyUserLabelMembersAdd'
        },
        resolve: {
            users,labels
        },
    });
}

/** @ngInject */
function users($stateParams) {
    return $stateParams.users;
}
/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}






// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/add/add-users-to-labels.state.js